// Cosmetics — fetch catalog, buy with gems, equip via PATCH /profile.
//
// Backend: /app/backend/cosmetics.py
import axios from "axios";
import { API, getOrCreateUserId } from "./api";

export async function fetchCosmeticsCatalog() {
  const uid = getOrCreateUserId();
  const res = await axios.get(`${API}/cosmetics/catalog`, { params: { user_id: uid } });
  return res.data;  // { skins: [], victory_anims: [], avatar_frames: [] }
}

export async function buyCosmetic(item_id) {
  const uid = getOrCreateUserId();
  const res = await axios.post(`${API}/cosmetics/buy`, { user_id: uid, item_id });
  return res.data;
}

// Equip an item by patching the corresponding active_* field on the profile.
export async function equipCosmetic(kind, item_id) {
  const field = {
    skin: "active_skin",
    victory_anim: "active_victory_anim",
    avatar_frame: "active_avatar_frame",
  }[kind];
  if (!field) throw new Error(`Unknown cosmetic kind: ${kind}`);
  const uid = getOrCreateUserId();
  const res = await axios.patch(`${API}/profile/${uid}`, { [field]: item_id });
  return res.data;
}
